/**
 * Formats a Date object into a string in the format DD/MM/YYYY.
 *
 * @param {Date} date - The Date object to be formatted.
 * @returns {string} - A string representing the formatted date.
 *
 * This function takes a Date object and returns a string representing the date in the format of day/month/year. Each component of the date (day, month, year) is processed to ensure a consistent two-digit format for days and months (prefixed with a '0' if necessary), and a four-digit format for the year. This is useful for standardizing the representation of dates in user interfaces or data exports.
 */
export function formatDate(date: Date) {
  const formattedDate = `${(`0${date.getDate()}`).slice(-2)
  }/${
    (`0${date.getMonth() + 1}`).slice(-2)
  }/${
    date.getFullYear()}`;
  return formattedDate;
}
